class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.renderBTP();
  }

  connectedCallback() {
    window.addEventListener("scroll", this.onScrollBTP.bind(this));
    this.querySelector("button.back-to-top_btn").addEventListener("click", this.onClickBTP.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollBTP.bind(this));
    this.querySelector("button.back-to-top_btn").removeEventListener("click", this.onClickBTP.bind(this));
  }

  onScrollBTP() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPosition = window.scrollY || document.body.scrollTop || document.documentElement.scrollTop;

    const footer = document.querySelector(".footer");
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;
    const footerVisible = scrollPosition + windowHeight >= footerTop;

    if (footerVisible) {
      this.style.display = "block";
    } else {
      this.style.display = "none";
    }
  }

  onClickBTP() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  renderBTP() {
    this.innerHTML = `
      <button class="back-to-top_btn" aria-label="Scroll to top">
        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 13.9414L6 1.00023L6 13.9414ZM6 1.00023L1 6.00023L6 1.00023ZM6 1.00023L11 6.00023L6 1.00023Z" fill="white"/>
          <path d="M6 13.9414L6 1.00023M6 1.00023L1 6.00023M6 1.00023L11 6.00023" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <small class="back-to-top__text">back to top</small>
      </button>
    `;
  }
}

customElements.define("back-to-top", BackToTop);
